import {
  Button,
  Descriptions,
  Form,
  Input,
  InputNumber,
  Modal,
  Space,
  Table,
} from "antd";
import React, { useState, useEffect } from "react";
import Layout from "../../../components/Layout";
import { request } from "../../../config/API";
import {
  ReloadOutlined,
  PlusOutlined,
  DeleteOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import authHeader from "../../../redux/services/authHeader";
import { COLORS } from "../../../config/theme";
import styles from "./ListAdmins.module.css";
import { openNotification } from "../../../redux/actions/Notification/notifications.action";
import { changePassword } from "../../../redux/actions/SuperAdmin/superadmin.actions";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useDebouncedCallback } from "use-debounce";
import { SUPER_ADMIN_EDITOR } from "../../../config/roles";

const ListAdmin = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    user: { role },
  } = useSelector((state) => state.auth);
  const { primaryDark } = COLORS;
  const [admins, setAdmins] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // pagination
  const [count, setCount] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  function handlePageChange(current) {
    setCurrentPage(current);
  }
  function handleSizeChange(a, b, c) {
    setCurrentPage(a);
    setPageSize(b);
  }

  const getAdmins = () => {
    setIsLoading(true);
    request
      .get("user/admin", {
        params: { pageSize, pageNumber: currentPage },
        headers: { ...authHeader() },
      })
      .then(({ data: { data } }) => {
        setAdmins(data?.admin);
        setCount(data?.count);
        setIsLoading(false);
        // setAdmins(data?.admin);
      })
      .catch((err) => {
        const error = err?.response?.data || "Something Happened";
        openNotification({
          message: "Error",
          description: error,
          icon: "error",
        });
        setIsLoading(false);
      });
  };
  useEffect(getAdmins, [currentPage, pageSize]);

  const columns = [
    {
      title: "Full Name",
      dataIndex: "fullName",
      key: "fullName",
      className: styles.antRow,
      ellipsis: true,
      width: "15%",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      className: styles.antRow,
      ellipsis: true,
      width: "10%",
    },
    {
      title: "Card Allowed",
      dataIndex: "qrAllowed",
      key: "qrAllowed",
      className: styles.antRow,
      width: "10%",
    },
    {
      title: "Card Unused",
      dataIndex: "qrUnused",
      key: "qrUnused",
      className: styles.antRow,
      width: "10%",
    },
    {
      title: "Subscription",
      dataIndex: "subuserUnused",
      key: "subuserUnused",
      className: styles.antRow,
      width: "10%",
      render: (row, entry) => {
        return (
          <span>
            {entry?.subscription?.paymentStatus === "SUCCESS"
              ? entry?.subscription?.selectedPlan
              : "BASIC"}
          </span>
        );
      },
    },
    {
      title: "Actions",
      key: "actions",
      render: (text) => {
        return (
          <Space>
            <Button
              size="middle"
              shape="round"
              onClick={() => {
                setQrQuanityData(text);
                setEditQrQuantitiModal(true);
                form3.setFieldsValue({
                  qrAllowed: text?.qrAllowed,
                  subuserAllowed: text?.subuserAllowed,
                });
              }}
            >
              Edit
            </Button>
            <Button
              size="middle"
              shape="round"
              onClick={() => {
                setSelectedUser(text);
                setIsChangePassVisible(true);
              }}
            >
              Change Password
            </Button>
            <Button
              size="middle"
              shape="round"
              danger
              disabled={role === SUPER_ADMIN_EDITOR}
              icon={<DeleteOutlined />}
              onClick={() => {
                setDeleteAdminData(text);
                setIsDeleteModalVisible(true);
              }}
            >
              Delete
            </Button>
          </Space>
        );
      },
    },
  ];
  const [form] = Form.useForm();
  const form2 = form;
  const [form3] = Form.useForm();
  const [form4] = Form.useForm();

  // edit qrAllowed Modal
  const [editQrQuantitiModal, setEditQrQuantitiModal] = useState(false);
  const [isEditting, setIsEditting] = useState(false);
  const [qrQuanityData, setQrQuanityData] = useState();

  const handleEditQrQuantity = (qrAllowed, id) => {
    setIsEditting(true);
    request
      .put(`user/admin/${id}`, { qrAllowed }, { headers: { ...authHeader() } })
      .then(() => {
        setIsEditting(false);
        setEditQrQuantitiModal(false);
        openNotification({
          message: "Success",
          description: "QR Quantity Updated!",
          icon: "success",
        });
        getAdmins();
      })
      .catch((err) => {
        const error = err?.response?.data?.data || "Something Happened";
        openNotification({
          message: "Error",
          description: error,
          icon: "error",
        });
        setIsEditting(false);
        // setEditQrQuantitiModal(false);
      });
  };
  // Change Password Modal
  const [isChangePassVisible, setIsChangePassVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isPassChanging, setIsPassChanging] = useState(false);

  const handlePasswordChange = (values) => {
    const data = { ...values, id: selectedUser?._id };
    setIsPassChanging(true);
    dispatch(changePassword(data))
      .then(() => {
        setIsPassChanging(false);
        openNotification({
          message: "Success!",
          description: "Password Updated Successfully",
          icon: "success",
        });
        setIsChangePassVisible(false);
        setSelectedUser({});
        form2.resetFields();
      })
      .catch((e) => {
        console.log("e =>", e);
        setIsPassChanging(false);
      });
  };

  // Delete Admin
  const [deleteAdminData, setDeleteAdminData] = useState({});
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isDeleteing, setIsDeleteing] = useState(false);
  const handleDeleteAdmin = (data) => {
    const { id, password } = data;
    setIsDeleteing(true);
    request
      .put(`user/${id}`, { password }, { headers: { ...authHeader() } })
      .then(() => {
        setIsDeleteing(false);
        setDeleteAdminData({});
        openNotification({
          message: "Success!",
          description: "Admin Deleted Successfully!",
          icon: "success",
        });

        setIsDeleteModalVisible(false);
        getAdmins();
      })
      .catch((err) => {
        setIsDeleteing(false);
        const error =
          err?.response?.message ||
          err?.response?.statusText ||
          "Something Happened";
        openNotification({
          message: "Error",
          description: error,
          icon: "error",
        });
      });
  };

  // Searching
  const [searchedData, setSearchedData] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [searchvalue, setSearchValue] = useState("");
  const [searchStatus, setSearchStatus] = useState("undecided");
  const onSearch = () => {
    setIsSearching(true);
    request
      .post(
        "/user/admin/search",
        { query: searchvalue },
        { headers: { ...authHeader() } }
      )
      .then(({ data: { data } }) => {
        setSearchedData(data);
        setIsSearching(false);
        setSearchStatus("success");
      })
      .catch((e) => {
        console.log("🚀 ~ file: QRCodes.jsx ~ line 142 ~ onSearch ~ e", e);
        setIsSearching(false);
        setSearchStatus("error");
      });
  };
  useEffect(() => {
    if (searchvalue === "") {
      setSearchedData([]);
      setSearchStatus("undecided");
    }
  }, [searchvalue]);
  const debounced = useDebouncedCallback(() => {
    onSearch();
  }, 500);
  useEffect(() => {
    if (!searchvalue) return;
    debounced(searchvalue);
  }, [debounced, searchvalue]);
  return (
    <Layout heading="Admins" hasBadge stat={count}>
      <Space style={{ marginBottom: 24, float: "right" }} wrap={true}>
        <Form
          onFinish={() => {
            if (searchvalue === "") {
              alert("Please enter some value!");
            } else {
              onSearch();
            }
          }}
          onFinishFailed={(x) => {
            console.log(x);
          }}
          style={{ display: "flex" }}
        >
          <Form.Item
            name="search"
            // label="Search"
            style={{ margin: 0 }}
          >
            <Input
              style={{ borderTopLeftRadius: 50, borderBottomLeftRadius: 50 }}
              allowClear
              value={searchvalue}
              onChange={(e) => {
                setSearchValue(e.target.value);
              }}
              placeholder="Search ..."
            />
          </Form.Item>
          <Form.Item style={{ margin: 0 }}>
            <Button
              type="primary"
              style={{
                width: 50,
                background: primaryDark,
                borderTopRightRadius: 50,
                borderBottomRightRadius: 50,
                border: "none",
                paddingLeft: 10,
                paddingRight: 10,
              }}
              htmlType="submit"
              loading={isSearching}
              icon={<SearchOutlined />}
            />
          </Form.Item>
        </Form>
        <Button
          shape="round"
          type="primary"
          style={{ background: primaryDark, borderColor: primaryDark }}
          // onClick={openModal}
          onClick={() => {
            history.push("/app/admin-detail/new");
          }}
          icon={<PlusOutlined />}
        >
          Add Admin
        </Button>
        <Button
          shape="round"
          type="primary"
          style={{ background: primaryDark, borderColor: primaryDark }}
          onClick={getAdmins}
          icon={<ReloadOutlined />}
        >
          Refresh
        </Button>
      </Space>
      {searchStatus === "success" ? (
        <Table
          size="large"
          dataSource={searchedData?.users}
          rowKey={({ _id }) => _id}
          columns={columns}
          pagination={{
            hideOnSinglePage: false,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} items`,
          }}
        />
      ) : (
        <Table
          size="large"
          dataSource={admins}
          rowKey={({ _id }) => _id}
          columns={columns}
          loading={isLoading}
          pagination={{
            hideOnSinglePage: true,
            pageSize: pageSize,
            current: currentPage,
            total: count,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} items`,
            // showTotal: (total) => `Total ${total} items`,
            onChange: handlePageChange,
            showSizeChanger: true,
            onShowSizeChange: handleSizeChange,
          }}
        />
      )}

      {/* Change Password Modal */}
      <Modal
        visible={isChangePassVisible}
        title="Change Password"
        footer={null}
        onCancel={() => {
          setIsChangePassVisible(false);
          setSelectedUser(null);
          form2.resetFields();
        }}
      >
        <Form form={form2} onFinish={handlePasswordChange}>
          <Form.Item
            labelCol={{ span: 7 }}
            labelAlign="left"
            label="Password"
            name="password"
            hasFeedback
            rules={[
              { required: true, message: "This field is required" },
              { min: 6, message: "Password should be atleast 6 characters" },
            ]}
          >
            <Input.Password size="large" style={{ borderRadius: 8 }} />
          </Form.Item>
          <Form.Item
            labelCol={{ span: 7 }}
            labelAlign="left"
            label="Re-Password"
            name="confirmPassword"
            hasFeedback
            dependencies={["password"]}
            rules={[
              { required: true, message: "This field is required" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error(
                      "The two passwords that you entered do not match!"
                    )
                  );
                },
              }),
            ]}
          >
            <Input.Password size="large" style={{ borderRadius: 8 }} />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0, textAlign: "right" }}>
            <Button
              loading={isPassChanging}
              type="primary"
              shape="round"
              style={{ background: primaryDark, borderColor: primaryDark }}
              size="large"
              htmlType="submit"
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        visible={editQrQuantitiModal}
        title="Edit Allowed QRs"
        onCancel={() => {
          setEditQrQuantitiModal(false);
          form3.resetFields();
        }}
        centered
        footer={null}
      >
        <Form
          name="editQrQuantity"
          form={form3}
          onFinish={(e) =>
            handleEditQrQuantity(e?.qrAllowed, qrQuanityData?._id)
          }
          onFinishFailed={(err) => console.error(err)}
        >
          <Form.Item label="Update QR Allowed" name="qrAllowed">
            <InputNumber
              style={{ width: "100%", borderRadius: 8 }}
              size="large"
            />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0, textAlign: "right" }}>
            <Button
              loading={isEditting}
              type="primary"
              shape="round"
              style={{ background: primaryDark, borderColor: primaryDark }}
              size="large"
              htmlType="submit"
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      {/* Delete Admin Modal */}
      <Modal
        visible={isDeleteModalVisible}
        title="Delete Admin"
        onCancel={() => {
          setIsDeleteModalVisible(false);
          setDeleteAdminData({});
          form4.resetFields();
        }}
        width={650}
        centered
        footer={null}
      >
        <Form
          name="deleteAdmin"
          form={form4}
          onFinish={(e) =>
            handleDeleteAdmin({ ...e, id: deleteAdminData?._id })
          }
          onFinishFailed={(err) => console.error(err)}
        >
          <Descriptions layout="horizontal" bordered column={2} size="middle">
            <Descriptions.Item label="Name" span={24}>
              {deleteAdminData?.fullName}
            </Descriptions.Item>
            <Descriptions.Item label="Email" span={24}>
              {deleteAdminData?.email}
            </Descriptions.Item>
            <Descriptions.Item label="QR Allowed">
              {deleteAdminData?.qrAllowed}
            </Descriptions.Item>
            <Descriptions.Item label="QR Unused">
              {deleteAdminData?.qrUnused}
            </Descriptions.Item>
            <Descriptions.Item label="Subuser Allowed">
              {deleteAdminData?.subuserAllowed}
            </Descriptions.Item>
            <Descriptions.Item label="Subuser Unused">
              {deleteAdminData?.subuserUnused}
            </Descriptions.Item>
          </Descriptions>

          <Form.Item
            label="Enter Password to verify"
            name="password"
            style={{ marginTop: 24 }}
            required
            rules={[{ required: true, message: "This field is required" }]}
          >
            <Input.Password style={{ borderRadius: 8 }} size="large" />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0, textAlign: "right" }}>
            <Button
              loading={isDeleteing}
              type="primary"
              shape="round"
              style={{ background: primaryDark, borderColor: primaryDark }}
              size="large"
              htmlType="submit"
            >
              Delete
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </Layout>
  );
};

export default ListAdmin;
